import Cookie from 'js-cookie'

const TOKEN_NAME = '_chat_auth'

export default {
    setToken(token) {
        Cookie.set(TOKEN_NAME, token, { expires: 7 });
    },

    getToken(name) {
        return Cookie.get(name || TOKEN_NAME);
    },

    deleteToken(token) {
        const name = token || TOKEN_NAME
        Cookie.remove(name)
    },

    getAuthToken() {
        let token = Cookie.get('_chat_auth_representation')

        if (!token) {
            token = Cookie.get(TOKEN_NAME)

            if (!token) {
                token = Cookie.get('authLogin')
            }
        }

        return token
    },
}
